import { logout } from 'features/auth';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetMeMutation } from 'services/user/user.endpoint';
import { useGetAllDatasMutation } from 'services/data/data.endpoint';
import { setDatalists } from 'features/datalist';
import { useApiToast } from 'components/Toaster';

export type useViewVMProps = {
    render: React.ReactNode;
};

export const useViewVM = ({ render }: useViewVMProps) => {
    const dispatch = useDispatch();
    const { showErrorToast } = useApiToast();
    // Get Me
    const [getMe, getMeResults] = useGetMeMutation();

    useEffect(() => {
        if (!getMe) return;
        getMe(undefined);
    }, [getMe, render]);

    useEffect(() => {
        if (!getMeResults) return;
        if (getMeResults.isError) {
            showErrorToast(getMeResults.error, {
                message: "Erreur lors de la récupération de l'utilisateur"
            });
            dispatch(logout());
        }
    }, [getMeResults, dispatch, showErrorToast]);

    // Get Datalists
    const [
        getAllDatas,
        {
            isLoading: isGetAllDatasLoading,
            isError: isGetAllDatasError,
            isSuccess: isGetAllDatasSuccess,
            error: datalistDataError,
            data: datalistDataResponse
        }
    ] = useGetAllDatasMutation();

    useEffect(() => {
        getAllDatas(undefined);
    }, [getAllDatas]);

    useEffect(() => {
        if (isGetAllDatasLoading) return;
        if (isGetAllDatasError && datalistDataError) {
            showErrorToast(datalistDataError, {
                message: 'Erreur de chargement des types de sources'
            });
            return;
        }
        if (isGetAllDatasSuccess && datalistDataResponse) {
            dispatch(setDatalists(datalistDataResponse.data));
            return;
        }
    }, [isGetAllDatasLoading, isGetAllDatasError, isGetAllDatasSuccess, datalistDataError, datalistDataResponse, showErrorToast, dispatch]);

    return {};
};
